import actionCreator from './action-creator';
import stateReducers from './state-reducers';

export default {
    actionCreator,
    stateReducers,
};
